import { createSelector } from 'reselect'
import interactiveVideoCreationModalSelector from 'redux/selectors/interactive_video_creation/modal_selector'

const modalStateSelector = state => state.modal
const gameModalsSelector = state => state.game.modals

const modalSelector = createSelector(
	[
		modalStateSelector,
		gameModalsSelector,
		interactiveVideoCreationModalSelector,
	],
	(
		modals,
		gameModals,
		interactiveVideoCreationModal,
	) => {
		let modal = modals.find(modal => modal.visible === true)

		if (!modal && gameModals.length) {
			modal = gameModals[0]
		}
		if (!modal) {
			modal = interactiveVideoCreationModal
		}

		return {
			modal,
		}
	}
)

export default modalSelector
